import {
  FETCH_QUESTION,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAIL,
  SEND_ANSWER,
  SEND_ANSWER_SUCCESS,
  SEND_ANSWER_FAIL,
  QUESTION_ANSWERED,
  QUESTION_ASKED,
  CLEAN_QUESTION
} from 'config/types';

const INITIAL_STATE = {
  isLoading: false,
  question: undefined,
  state: QUESTION_ASKED
};

export default function question(state=INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_QUESTION:
      return {...state, isLoading: true, state: QUESTION_ASKED};
    case FETCH_QUESTION_SUCCESS:
      return {...state, isLoading: false, state: QUESTION_ASKED, question: action.payload};
    case FETCH_QUESTION_FAIL:
      return {...state, isLoading: false, state: QUESTION_ASKED};
    case SEND_ANSWER_SUCCESS:
      return {...state, isLoading: false, state: QUESTION_ANSWERED, question: action.payload};
    case SEND_ANSWER_FAIL:
      return {...state, isLoading: false, state: QUESTION_ANSWERED};
    case CLEAN_QUESTION:
      return {...state, question: undefined, state: QUESTION_ASKED};
    default:
      return state;
  }
}
